import React from 'react';
import {observer} from 'mobx-react';
import {LongtailKPI} from '../kpi';
import {stylesheet} from 'typestyle';
import DashboardStore from '../stores/DashboardStore';
import {BlackColor} from '../styles/colors';

interface LongtailLimitProps {
    kpi: LongtailKPI;
    dashboardStore: DashboardStore;
    value: number;
}

@observer
export default class LongtailLimitSelect extends React.Component<LongtailLimitProps> {
    private preventLinkClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    private onSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = parseInt(e.currentTarget.value, 10);
        if (!isNaN(value)) {
            this.props.dashboardStore.setLongtailLimitAndReloadDiagram(this.props.kpi, value);
        }
    };

    public render() {
        return (
            <div className={longtailSelectCss.root} onClick={this.preventLinkClick}>
                <select value={this.props.value} className={longtailSelectCss.select} onChange={this.onSelectionChange}>
                    <option className={longtailSelectCss.option}>1000</option>
                    <option className={longtailSelectCss.option}>500</option>
                    <option className={longtailSelectCss.option}>100</option>
                </select>
            </div>
        );
    }
}

const longtailSelectCss = stylesheet({
    root: {
        display: 'inline-block',
        verticalAlign: 'top',
    },
    option: {
        color: BlackColor,
    },
    select: {
        backgroundColor: 'transparent',
        fontSize: '90%',
    },
});



// WEBPACK FOOTER //
// ./src/views/LongtailLimitSelect.tsx